import type { FC } from "react";

import { SignUpForm } from "~/feature/auth/components/SignUpForm";
import { SignUpSuccessDialog } from "~/feature/auth/components/SignUpSuccessDialog";

interface IFooterSignUpFormProps {
  buttonLabel?: string;
  stacked?: boolean;
}

export const FooterSignUpForm: FC<IFooterSignUpFormProps> = ({
  buttonLabel,
  stacked,
}) => {
  return (
    <SignUpSuccessDialog>
      {(handleSuccess) => (
        <SignUpForm
          onSuccess={handleSuccess}
          small={!stacked}
          stacked={stacked}
          buttonLabel={buttonLabel}
        />
      )}
    </SignUpSuccessDialog>
  );
};
